import { render } from "./CollaboratorImport.vue?vue&type=template&id=7e144e5e&scoped=true"
import script from "./CollaboratorImport.vue?vue&type=script&lang=js"
export * from "./CollaboratorImport.vue?vue&type=script&lang=js"

import "./CollaboratorImport.vue?vue&type=style&index=0&id=7e144e5e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e144e5e"]])

export default __exports__